import type { ComponentProps } from 'react'
import ReadinessResults from '@/app/(app)/tools/ai-readiness-score/components/ReadinessResults'
import type { ToolDetailProps } from './detailRegistry'

/**
 * Dashboard detail renderer for `readiness` (Phase 3, Step 9 — Class B,
 * dashboard-reuse). This REPLACES the legacy inline `readiness` branch that
 * lived in `ToolDetailPanel`.
 *
 * REUSES the public `ReadinessResults` with `variant="dashboard"`, which hides
 * the public-only chrome (the email-share row, PlatformCTA, and the gradient
 * services CTA). The platform route (`/api/platform/tools/ai-readiness`) runs
 * the same lib and returns the same `AiReadinessResult`, so the dashboard
 * `data` maps straight onto the component — the dashboard now shows the full
 * rich report (score ring, crawl/llms availability badges, readiness radar, AI
 * analysis, the five category score cards with findings, recommendations with
 * blog links) instead of the generic panel.
 *
 * Wrapped in `id="tool-detail-panel"` so the dashboard scroll-to-panel still
 * works. Grade comes from `data.grade` via the reused component — never
 * recomputed; the five-axis category model is unchanged. Render-layer only.
 */
export function ReadinessDashboardDetail({ data }: ToolDetailProps) {
  const result = data as unknown as ComponentProps<
    typeof ReadinessResults
  >['result']
  return (
    <div
      id='tool-detail-panel'
      className='rounded-xl border border-border bg-card p-5'
    >
      <ReadinessResults result={result} variant='dashboard' />
    </div>
  )
}
